import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useFieldView } from "../contexts/form-view-context.js";
import { calculateGridStyles } from "../utils/grid-styles.js";
import { isInputField } from "../ui/form/types/form-view.js";
const DefaultFieldLayout = ({
  fieldId,
  ...rest
}) => {
  const fieldView = useFieldView(fieldId);
  if (!fieldView) {
    return null;
  }
  const { layout, fieldType } = fieldView;
  const dataHook = `form-field-${isInputField(fieldView) ? fieldView.target : fieldView.id}`;
  const dataAttributes = {
    "data-hook": dataHook,
    "data-field-type": fieldType
  };
  const gridStyles = calculateGridStyles({ layout });
  if ("children" in rest) {
    return /* @__PURE__ */ jsx("div", { style: gridStyles.container, ...dataAttributes, children: rest.children });
  }
  const { renderLabel, renderInput, renderDescription } = rest;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { style: gridStyles.label, children: renderLabel() }),
    /* @__PURE__ */ jsxs("div", { style: gridStyles.input, ...dataAttributes, children: [
      renderInput(),
      renderDescription()
    ] })
  ] });
};
export {
  DefaultFieldLayout
};
//# sourceMappingURL=default-field-layout.js.map
